export const TRANSACTION_ACCEPTED_ATTEMPT = "TRANSACTION_ACCEPTED_ATTEMPT";
export const TRANSACTION_ACCEPTED_SUCCESS = "TRANSACTION_ACCEPTED_SUCCESS";
export const TRANSACTION_ACCEPTED_FAILED = "TRANSACTION_ACCEPTED_FAILED";
export const LOGOUT = "LOGOUT";